import { debounce } from 'lodash';
import { useCallback, useEffect, useRef, useState } from 'react';
import isFunction from 'utils/isFunction';
export default function useDebounceMutation(delay = 1000) {
    const [debounceDelay, setDebounceDelay] = useState();
    const [saving, setSaving] = useState(false);
    const pendingRef = useRef(false);
    useEffect(() => {
        setDebounceDelay(delay);
    }, [delay]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debounceUpdate = useCallback(debounce((update, variables, onError) => {
        update({ variables })
            .then(() => {
            pendingRef.current = false;
            setSaving(false);
        })
            .catch((err) => {
            pendingRef.current = false;
            setSaving(false);
            if (isFunction(onError) && onError)
                onError(err);
            else
                throw err;
        });
    }, debounceDelay), [debounceDelay]);
    const debounceUpdateWithSaving = useCallback((update, variables, onError) => {
        pendingRef.current = true;
        setSaving(true);
        debounceUpdate(update, variables, onError);
    }, [debounceUpdate]);
    return [debounceUpdateWithSaving, saving];
}
